import { render, staticRenderFns } from "./BulkInvoices.vue?vue&type=template&id=0337c82e&"
import script from "./BulkInvoices.vue?vue&type=script&lang=js&"
export * from "./BulkInvoices.vue?vue&type=script&lang=js&"
import style0 from "./BulkInvoices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports